import React, {useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {regSysFWList} from "../../api/apiClient";
import ComboFirmType from "../../components/inputs/ComboFirmType";
import Swal from "sweetalert2";
import '@sweetalert2/theme-dark/dark.scss';

const RegFirmware = ({
                       hClose
                     }) => {

  const [firmwareInfo, setFirmwareInfo] = useState({
    device_ty: '',
    fw_ver: '',
    mkr: '',
    fw_file: null,
  });

  const onChangeInfo = (name, value, isMany = false) => {
    let newInfo = {...firmwareInfo};
    if (isMany) {
      for (let i = 0; i < name.length; i++) {
        newInfo[name[i]] = value[i]
      }
    } else {
      newInfo[name] = value;
    }

    setFirmwareInfo(newInfo);
  };

  const onSubmitFirmwareForm = () => {
    if (firmwareInfo.device_ty === '') {
      Swal.fire(
          '펌웨어 타입은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (firmwareInfo.fw_ver === '') {
      Swal.fire(
          '펌웨어 버전은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (firmwareInfo.mkr === '') {
      Swal.fire(
          '장비제조사는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (firmwareInfo.fw_file === null) {
      Swal.fire(
          '파일은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    regSysFWList(firmwareInfo)
        .then((res) => {
          let data = res.data;
          Swal.fire(
              '정상적으로 처리 되었습니다!',
              '',
              'success'
          );
          hClose();
        })
        .catch(err => {
          Swal.fire(
              err.response.data.message,
              '',
              'error'
          );
        });
  };

  return (
      <Row className={"layer"}>
        <Col className={''}>
          <Row className={'info-container py-2 mx-3'}>
            <Col md={11} className={'px-5'}>
              <div className={'content-container-body-item'}>
                <Form
                    className={'gateway-register-form py-3'}
                    id={'firmwareRegisterForm'}
                >
                  <Row className={"justify-content-center"}>
                    <Col md={12}>
                      <Row>
                        <Col md={12}>
                          <ComboFirmType
                              propLabel={"펌웨어 타입"}
                              propOnChange={(e) => {
                                onChangeInfo('device_ty', e.target.value);
                              }}
                              propLabelRatio={4}
                              propLocation={"FIELD"}
                          />
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formIp1Addr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>펌웨어 버전
                            </Form.Label>
                            <Col md={8} className={''}>
                              <Form.Control
                                  type='number'
                                  className={'input text-white'}
                                  step={"0.1"}
                                  onChange={(e) => {
                                    onChangeInfo('fw_ver', e.target.value);
                                  }}
                                  // defaultValue={(firmwareInfo !== null) ? firmwareInfo.fw_ver : '' || ''}
                                  value={(firmwareInfo !== null) ? firmwareInfo.fw_ver : '' || ''}
                                  required
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formIp2Addr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>장비제조사
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo('mkr', e.target.value);
                                  }}
                                  // defaultValue={(firmwareInfo !== null) ? firmwareInfo.mkr : '' || ''}
                                  value={(firmwareInfo !== null) ? firmwareInfo.mkr : '' || ''}
                                  required
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='forml2IpAddr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>파일명
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='file'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo(['fw_file', 'file_sz'],
                                        [e.target.files[0], e.target.files[0].size],
                                        true);
                                  }}
                                  // defaultValue={(firmwareInfo !== null) ? firmwareInfo.file_nm : '' || ''}
                                  value={(firmwareInfo !== null) ? firmwareInfo.file_nm : '' || ''}
                                  required
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formFcltyNm'>
                            <Form.Label column md={4} className={'label text-end'}>
                              파일사이즈 (Bytes)
                            </Form.Label>
                            <Col md={8} className={''}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white text-end'}
                                  // defaultValue={(firmwareInfo !== null) ? firmwareInfo.file_sz : '' || ''}
                                  value={(firmwareInfo !== null) ? firmwareInfo.file_sz : '' || ''}
                                  disabled={true}
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                      </Row>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
          <Row className={"my-3 justify-content-center"}>
            <Col md={2} className={'justify-content-center'}>
              <Button
                  className={'btn save-btn w-100'}
                  onClick={onSubmitFirmwareForm}
              >저장</Button>
            </Col>
            <Col md={2} className={'justify-content-center text-end'}>
              <Button className={'btn btn-secondary w-100'} onClick={hClose}>취소</Button>
            </Col>
          </Row>
        </Col>
      </Row>
  );
};

export default RegFirmware;
